import React from "react";
import HackTransactions from "../components/hacks/HackTransactions";

import HackLayout from "../components/hacks/HackLayout";

const HackTransactionPage = () => {
  return (
    <HackLayout activeId="transactions">
      <div className="space-y-12">
        <HackTransactions title="Red" collectioName="redTeamTransactions" />
        <HackTransactions title="Blue" collectioName="blueTeamTransactions" />
      </div>
    </HackLayout>
  );
};

export default HackTransactionPage;
